import absurd from 'utility/absurd';

export enum AsyncValueState {
  fetched,
  fetching,
  error,
}

export type AsyncValue<Value> =
  | { type: AsyncValueState.fetched; value: Value }
  | { type: AsyncValueState.fetching }
  | { type: AsyncValueState.error };

export type Type<Value> = AsyncValue<Value>;

export const fetched = <Value>(value: Value): AsyncValue<Value> => ({
  type: AsyncValueState.fetched,
  value,
});
export const fetching = <Value>(): AsyncValue<Value> => ({
  type: AsyncValueState.fetching,
});
export const error = <Value>(): AsyncValue<Value> => ({
  type: AsyncValueState.error,
});

export function branch<Output, Value>(
  asyncValue: AsyncValue<Value>,
  branches: {
    fetched: (value: Value) => Output;
    fetching: () => Output;
    error: () => Output;
  }
): Output {
  switch (asyncValue.type) {
    case AsyncValueState.fetched:
      return branches.fetched(asyncValue.value);
    case AsyncValueState.fetching:
      return branches.fetching();
    case AsyncValueState.error:
      return branches.error();
    default:
      return absurd(asyncValue);
  }
}

export function flattenRecord<T>(record: Record<string, AsyncValue<T>>): Record<string, T> {
  const out: Record<string, T> = {};

  for (const key of Object.keys(record)) {
    branch(record[key], {
      fetched: (x) => { out[key] = x; },
      fetching: () => {},
      error: () => {},
    });
  }

  return out;
}
